import { ExpandedTable } from './ExpandedTable';
import { Item } from '../../types/item.types';
import RenderIfVisible from 'react-render-if-visible';
import { StyledTableRow } from '../../../../shared/styles/components/table.styles';
import { SubItem } from '../../types/sub-item.types';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { tokens } from '../../../../shared/styles/core/tokens';
import { useExpandedOnRow } from '../../state/expanded-rows.state';

type ExpandedRowProps = {
   parentIndex: number;
   columnSpan: number;
   subItems?: SubItem[];
   parentItem: Item;
};

const StyledInnerTableDiv = styled.div`
   position: sticky;
   left: 0;
   width: calc(100vw - 2 * ${tokens.space['3xl']});
   padding: ${tokens.space.md} ${tokens.space.lg} ${tokens.space.lg} 0;
`;


const conditionalTableDataStyle = (props: { isExpanded: boolean }) => {
   if (!props.isExpanded)
      return css`
         border: none !important;
      `;
};

const StyledTableData = styled.td`
   ${conditionalTableDataStyle};
   padding: 0 !important;
`;

export const ExpandedRowWrapper = ({ parentIndex, columnSpan, subItems, parentItem }: ExpandedRowProps) => {
   const { isExpanded } = useExpandedOnRow(parentIndex);

   return (
      <StyledTableRow key={parentIndex} noHover={true}>
         <StyledTableData colSpan={columnSpan} isExpanded={isExpanded}>
            {isExpanded ? (
               <RenderIfVisible visibleOffset={1000}>
                  <div>
                     <StyledInnerTableDiv>
                        <ExpandedTable subItems={subItems} parentIndex={parentIndex} parentItem={parentItem} />
                     </StyledInnerTableDiv>
                  </div>
               </RenderIfVisible>
            ) : null}
         </StyledTableData>
      </StyledTableRow>
   );
};
